export const general = {
	main: {
		main: 'Ana Sayfa',
		quests: 'Görevler',
		enter: 'Giriş',
		register: 'Registration',
		begin: 'Başla',
		take: 'Al',
		begin_quest: 'Göreve Başla',
		rockets_try_another_filters: 'Try different filter settings or go to the Hero section on the Parik24 website',
		product_filter: 'Sırala',
		loading: 'Sayfa Yükleniyor...',
		reset_filters: 'Sıfırla',
		readMoreBtn: 'Daha fazla',
		back: 'Geri',
		next: 'İleri',
		bonus_shop: 'Bonus shop',
		all: 'Tümü',
		status: 'Durum',
		buy_history: 'Satın alma geçmişi',
		points: 'Puan',
		points_p: 'puan',
		common: 'Sıradan',
		rare: 'Nadir',
		epic: 'Destansı',
		legendary: 'Efsanevi',
		to_increase: 'Artan sırayla',
		to_decrease: 'Azalan sırayla',
		nothing_here: 'Burada henüz bir şey yok',
		account: 'Hesap Numarasi',
		phone: 'Telefon',
		password: 'Şifre',
		to_enter: 'Giriş yap',
		buy: 'Satın Al',
		close: 'Kapat',
		congratulations: 'Tebrikler!',
		delivered: 'Gönderilmiş',
		send: 'Gönderilmiş',
		cancel: 'İptal etmek',
		shop: 'Mağaza',
		sections: 'Bölümler',
		apply: 'Uygula',
		reset_all: 'Her şeyi sıfırla',
		clear: 'Anladım',
		more: 'Daha fazla',
		nomadHomeTitle: 'Магазин Бонусов NOMAD приветствует вас!',
		promotions: 'Kampanyalar',
		doBetsNomad: 'Делай ставки с NOMAD',
		faq: 'SSS',
		participant: 'Katılımcı',
		participants: 'Katılımcılar',
		prize: 'Ödül',
		pmPoints: 'PM points',
		pmPointsPlural: 'PM баллов',
		help: 'Destek',
		profile: 'Profil',
		blitzCoins: 'Coins',
		filters: 'Filtreler',
		sort_by: 'Göre sırala:',
		categories: 'Kategoriler',
		email: 'E-posta',
		out_of_stock: 'Stokta yok',
		duration: 'Süre',
		leaders: 'Liderler',
		refresh: 'Yenile',
		loading_common: 'Yükleniyor',
		join: 'Katıl',
		starting_soon: 'Yakında',
		before_start: 'Başlamasına kalan:',
		before_finish: 'Bitmesine kalan:',
		bonuses: 'Bonuslar',
		jackpot: 'Jackpot',
		filter: 'Filtre',

		//Date Plurals
		seconds_plur_one: '{{prefix}}saniye{{suffix}}',
		seconds_plur_few: '{{prefix}}saniye{{suffix}}',
		seconds_plur_many: '{{prefix}}saniye{{suffix}}',
		seconds_plur_other: '{{prefix}}saniye{{suffix}}',

		minutes_plur_one: '{{prefix}}dakika{{suffix}}',
		minutes_plur_few: '{{prefix}}dakika{{suffix}}',
		minutes_plur_many: '{{prefix}}dakika{{suffix}}',
		minutes_plur_other: '{{prefix}}dakika{{suffix}}',

		hours_plur_one: '{{prefix}}saat{{suffix}}',
		hours_plur_few: '{{prefix}}saat{{suffix}}',
		hours_plur_many: '{{prefix}}saat{{suffix}}',
		hours_plur_other: '{{prefix}}saat{{suffix}}',

		days_plur_one: '{{prefix}}gün{{suffix}}',
		days_plur_few: '{{prefix}}gün{{suffix}}',
		days_plur_many: '{{prefix}}gün{{suffix}}',
		days_plur_other: '{{prefix}}gün{{suffix}}',

		weeks_plur_one: '{{prefix}}hafta{{suffix}}',
		weeks_plur_few: '{{prefix}}hafta{{suffix}}',
		weeks_plur_many: '{{prefix}}hafta{{suffix}}',
		weeks_plur_other: '{{prefix}}hafta{{suffix}}',

		months_plur_one: '{{prefix}}ay{{suffix}}',
		months_plur_few: '{{prefix}}ay{{suffix}}',
		months_plur_many: '{{prefix}}ay{{suffix}}',
		months_plur_other: '{{prefix}}ay{{suffix}}',

		years_plur_one: '{{prefix}}yıl{{suffix}}',
		years_plur_few: '{{prefix}}yıl{{suffix}}',
		years_plur_many: '{{prefix}}yıl{{suffix}}',
		years_plur_other: '{{prefix}}yıl{{suffix}}',

		second_short: 's',
		minute_short: 'd',
		hour_short: 's',
		day_short: 'g',
		week_short: 'hf',
		month_short: 'ay',
		year_short: 'y',

		//Other Plurals
		points_plur_one: '{{prefix}}puan{{suffix}}',
		points_plur_few: '{{prefix}}puan{{suffix}}',
		points_plur_many: '{{prefix}}puan{{suffix}}',
		points_plur_other: '{{prefix}}puan{{suffix}}',

		// Gender forms
		finished_m: 'Tamamlandı',
		finished_f: 'Tamamlandı',
		finished_n: 'Tamamlandı',
		finished_p: 'Tamamlandı',

		in_progress_m: 'Devam ediyor',
		in_progress_f: 'Devam ediyor',
		in_progress_n: 'Devam ediyor',
		in_progress_p: 'Devam ediyor',

		days: {
			singular: 'gün',
			pair: 'gün',
			plural: 'gün',
			short: 'g'
		},
		weeks: {
			singular: 'hafta',
			pair: 'hafta',
			plural: 'hafta',
			short: 'hf'
		},
		hours: {
			singular: 'saat',
			pair: 'saat',
			plural: 'saat',
			short: 's'
		},
		minutes: {
			singular: 'dakika',
			pair: 'dakika',
			plural: 'dakika',
			short: 'd'
		},
		seconds: {
			singular: 'saniye',
			pair: 'saniye',
			plural: 'saniye',
			short: 's'
		}
	},
	coin_race: {
		title: 'Coin Yarışı',
		description: 'Oyuncular arasındaki bir yarışma. Yarış süresince en fazla {{points}} topla ve değerli ödüller kazan',
		jackpot_info: {
			title: 'Jackpot',
			description: 'Jackpot, yarışma süresince toplanan puanlardan bir çarpan olarak eklenir',
			description2: 'Daha fazla puan topladığınız ve diğer oyunculardan da fazla puan topladığınızda jackpot büyür',
			description3: 'Puanlarınız kendinizde kalır, hiçbir puan sizden çıkarılmaz',
			description4: 'Jackpot, yarış kurallarına göre kazananlara bölünür'
		},
		error: {
			races: 'Coin yarışları yüklenemedi. Lütfen sayfayı yenileyin veya daha sonra tekrar deneyin.'
		},
		info: {
			points: {
				title: 'Puanlar',
				description: 'Puanlar yarış puanlarına eklenir'
			},
			duration: {
				title: 'Süre',
				description: 'Yarışların süresi farklı olabilir'
			},
			participation: {
				title: 'Katılım',
				description: 'Katılmak için “Katıl” butonuna tıklayın'
			},
			prizes: {
				title: 'Ödüller',
				description: 'Ödüller sabit veya jackpot olabilir'
			}
		},
		filters: {
			title: 'Bitiş süresine göre sırala:',
			my_races: 'Benim yarışlarım',
			races: 'Yarışlar'
		},
		emptyState: {
			active: 'Aktif yarış yok',
			pending: 'Yaklaşan yarış yok',
			completed: 'Tamamlanan yarış yok'
		}
	},
	coin_race_details: {
		prize: 'Ödül',
		place: 'Mesafe',
		points: 'Puan',
		finished: 'Yarış tamamlandı',
		time_left_label: 'YARIŞIN BİTMESİNE KALAN:',
		rules_title: 'Katılım kuralları',
		prizes_coming_soon: 'Ödüller yakında',
		leave_action: 'Yarıştan ayrıl',
		no_participants: 'Henüz katılımcı yok',
		modals: {
			join_success: '<strong>"{{raceName}}"</strong> yarışına başarıyla katıldınız',
			leave_confirmation: 'Turnuvadan ayrılmak istediğinize emin misiniz? Tüm puanlar iptal edilecek.'
		}
	},

	faq: {
		faq_top: 'Frequently asked questions'
	},
	welcome: {
		intro_title: '- harika ödüller dünyasına geçişiniz',
		intro_text1: 'Bu, Parimatch şirketinin resmi ürünüdür.',
		intro_text2:
			'Görevleri tamamlayın ve bonus puanlar kazanın, bunları freebet, CS2 ve Dota2 görünümleri, lootboxlar ve mağazadaki diğer öğelerle değiştirin.',
		shop_and_quests_shop: 'Görevler ve ',
		shop_and_quests_quests: 'mağazalar',
		shop_and_quests_text1: 'Çok basit. Görevler sayfasında size sunulan görevleri takip edin.',
		shop_and_quests_text2:
			'Her görevde kaç PM puanı alacağınız belirtilmiştir. Tamamladıktan sonra puanlarınız pm-pass profilinize eklenecektir.',
		shop_and_quests_text3: 'Bunları Mağaza sayfasında değiştirebilirsiniz.',
		quest_guide: 'Tebrikler, bir adım uzaktasınız',
		quest_guide_hg: 'harika ödüllerden',
		obj_one_title: 'Parimatch ile puan kazanın',
		obj_one_desc: 'PM Puanları, görevleri tamamlayarak ve sticker kitaplarını toplayarak kazanılabilir.',
		obj_two_title: 'İlk göreviniz',
		obj_two_desc: 'Doğrulamayı tamamlayın ve 2000 KZT değerinde freebet ve 300 PM PASS puanı kazanın.',
		trade_link_text1:
			'Steam takas bağlantınızı ekleyin, böylece PM Pass mağazasında görünümler ve oyun içi öğeler alabilirsiniz',
		xpass_trade_link_text1:
			'Steam takas bağlantınızı ekleyin, böylece X-Pass mağazasında görünümler ve oyun içi öğeler alabilirsiniz',
		com2_trade_link_text1:
			'Steam takas bağlantınızı ekleyin, böylece Vip House mağazasında görünümler ve oyun içi öğeler alabilirsiniz',
		trade_link_text2: 'Bağlantı nasıl alınır?',
		steam_text: 'Dota 2’de görevleri tamamlamak için Steam hesabınızı eklemeniz gerekir',
		skip_step: 'Bu adımı atlayabilir ve bağlantıyı daha sonra ekleyebilirsiniz',
		steps: 'Adımlar:',
		steps_one: '1. parimatch.kz sitesine gidin',
		steps_two: '2. Kayıtlı olduğunuz telefon numarası ile giriş yapın',
		steps_three: '3. Kişisel kabinete gidin ve “Hesap Doğrulama” bölümüne girin',
		rockets_intro1: 'Şarj ol ',
		rockets_intro1_description:
			'Bonus Mağaza’da puanlarınızla istediğinizi satın alın: freebetler, ücretsiz dönüşler, spor ve casino için nakit bonuslar ve daha fazlası. Seçim sizin!',
		rockets_intro_button: 'Ödüllerle şarj ol',
		rockets_intro2: 'Ödülleri topla',
		rockets_intro2_description:
			'Görevler Parik24’ten bonuslar ve diğer ödüller verir. Görev ne kadar zorsa, ödül o kadar değerlidir!'
	},
	rockets_faq: {
		question1: 'How to participate?',
		question2: 'Who can participate?',
		answer1_text1: 'To participate:',
		answer1_text2: 'Log in and go to the Hero page;',
		answer1_text3: 'Click the «Participate» button to confirm your participation;',
		answer1_text4: 'Complete quests every day and receive guaranteed bonuses and points;',
		answer1_text5: 'Collect points and climb the player rankings;',
		answer1_text6: 'The higher the bet amount, the higher the ranking and better the prizes.',
		answer2_text1: 'Only individuals who are 18 years or older at the start of the promotion can participate.'
	},
	activity_history: {
		status: 'Durum',
		title: 'Satın alma geçmişi',
		date: 'Tarih',
		item: 'Ürün',
		amount: 'Puan karşılığı'
	},
	notifications: {
		steam_attached: 'Steam account linked',
		dota_history_opened: 'Match history is open',
		trade_link_attached: 'Trade URL attached',
		trade_link_edited: 'Trade URL updated',
		steam_edited: 'Steam account changed',
		present_applied: 'Satın alımınız için tebrikler!',
		present_send: 'The gift is already in Steam. Hurry up to claim it!',
		present_send_bonus: 'Freebet уже в Parimatch. Спешите активировать!',
		rockets_present_send_bonus: 'Freebet is already in Parik24. Hurry up to activate it!',
		present_send_merch:
			'Satın aldığınız için tebrikler! Teslimat bilgilerini bildirmek için müşteri hizmetlerine başvurun.',
		not_enough_cash: 'У вас недостаточно PM баллов для обмена',
		points_not_enough_cash: 'You don’t have enough points to trade',
		add_trade_link: 'Add your Steam trade URL to your Profile ',
		technical_issues: 'Teknik bakım devam ediyor. İşlem yapılamıyor.',
		account_copied: 'Hesap Kimliği kopyalandı',
		steam_copied: 'Steam ID copied',
		wrong_trade_link: 'Invalid trade URL format',
		not_enough_cash_blitz: 'Takas yapmak için yeterli Taç Coin’in yok',
		present_send_bonus_blitz: 'Freebet hazır. Hemen aktive et!',
		present_send_blitz: 'Satın alındı!'
	},
	shop: {
		closingText:
			'Mağaza ayın sonuna kadar açık — puanlarını kullanmaya yetiş. Senin için özel olarak yeni bir şey hazırlıyoruz!',
		notAvailable: 'Mağaza şu anda kullanılamıyor — lütfen web sitesindeki güncellemeleri bekleyin.'
	},
	errors: {
		loginError: 'Veriler hatalı girilmiş gibi görünüyor veya henüz bir hesabınız yok.',
		min_6_symbols: 'Minimum 6 karakter',
		min_1_number: 'Minimum 1 rakam (0-9)',
		number_registered: 'Telefon numarası zaten kayıtlı',
		not_supported: 'Telefon numarası desteklenmiyor',
		error_data: 'Veri işleme hatası',
		no_account: 'Veriler hatalı girilmiş gibi görünüyor veya henüz bir hesabınız yok.',
		cancel_reason: 'İptal Nedeni',
		user_has_shop_disabled: 'Teknik bakım devam ediyor. İşlem yapılamıyor.',
		user_has_no_steam_trade_url: 'Add your Steam trade URL to your Profile',
		shop_item_not_published: 'Item is no longer available for purchase.',
		user_has_not_enough_pm_points: "You don't have enough PM points to trade",
		user_has_not_enough_points: "You don't have enough points to trade",
		user_reached_limit_24h: 'Ne yazık ki günlük limitiniz aşıldı.',
		user_reached_limit_per_user: 'Ne yazık ki günlük limitiniz aşıldı.',
		items_in_stock_reached_limit: 'Item is out of stock.',
		rea_bonus_callback_error: 'Bonus işleme hatası. Destek ekibiyle iletişime geçin.',
		lottery_is_expired: 'Lottery participation period has expired.',
		shop_item_is_not_lottery: 'This item is not a lottery ticket.',
		bad_item_params_error: 'Invalid item parameters.',
		default:
			'Teknik bir nedenden dolayı ürün satın alınamadı. Daha fazla bilgi için lütfen destek ekibiyle iletişime geçin.',
		user_has_not_enough_blitz_points: 'Takas yapmak için yeterli Taç Coin’in yok',
		present_send_bonus_blitz: 'Freebet hazır. Hemen aktive et!',
		present_send_blitz: 'Satın alındı!'
	},
	promotions: {
		promotions: 'Акции',
		chip_new: 'Новое',
		chip_started: 'Началось',
		chip_participating: 'Учавствуете',
		tickets_buy: 'Купить билеты',
		to_promo_start: 'До старта осталось',
		to_promo_end: 'До конца акции осталось',
		GuideTitle: 'Как принять участие',
		GuideCardTitle1: 'Принимайте участие',
		GuideCardTitle2: 'Приобретайте билеты',
		GuideCardTitle3: 'Проверяйте результаты',
		GuideCardDescription1: 'Принимайте участие и присоединяйтесь к розыгрышу за считанные секунды!',
		GuideCardDescription2: 'Переходите в магазин и приобретайте билеты для участия в акции',
		GuideCardDescription3: 'Вы сможете отслеживать результаты акции в личном кабинете',
		participants: 'Участники',
		participants_amount: 'Количество участников',
		look_participants: 'Посмотреть участников',
		participants_table: 'Таблица участников',
		noParticipantsYet: 'Пока никто не участвует!',
		seeEveryone: 'Посмотреть всех',
		tickets: 'Билеты',
		ticketsAmount: 'Количество билетов',
		FaqCardTitle1: 'Где посмотреть результаты розыгрыша?',
		FaqCardTitle2: 'Влияет ли количество билетов на шанс победы?',
		FaqCardTitle3: 'Когда станут известны результаты?',
		FaqCardDescription1:
			'Все итоги доступны в личном кабинете и на странице самой лотереи — заходите и проверяйте, не попали ли вы в список победителей!',
		FaqCardDescription2:
			'Да! Чем больше у вас билетов, тем выше шанс выиграть. Каждый билет — это дополнительная возможность стать победителем.',
		FaqCardDescription3:
			'Дата и время подведения итогов указаны на странице акции. Не забудьте заглянуть туда — всё прозрачно и точно по расписанию!',
		WinCongrats: 'Поздравляем с победой!',
		YouWinIn: 'Поздравляем вас с победой в',
		ContactSupport: 'Для подробной информации свяжитесь с поддержкой.',
		WinnersList: 'Список победителей'
	},
	banner: {
		title: 'Parimatch ile farm yapın',
		subtitle: 'Görevleri tamamlayın, PM puanları kazanın ve harika ödüllerle değiştirin',
		btn: 'Ödülleri farm yapın',
		title1: 'Görevleri',
		title1_hg: 'tamamlayın',
		trophy_title: "<span style='color: #F2F740;'>En İyi</span> espor bahis sitesi",
		trophy_title_hg: "<span style='color: #F2F740;'>Kazakistan'da</span>",
		title2: 'Puan',
		title2_hg: 'kazanın',
		title3_hg: '',
		title3: '<span>skinlerle</span> değiştirin',
		title3_suffix: 'değiştirin',
		button: 'Başla',
		promocodeText: `Parimatch'te <span>"EZGAME"</span> promosyon kodu ile 5.000 ₸ ücretsiz bahis kazanın.`
	},
	blitzWelcome: {
		title1: 'Yeni Fırsatlar: Bonus Satın Al & Büyük Ödülleri Kazan',
		title2: 'Şan için Taç Coin kazan!',
		title3: 'Kraliyet Hazinesi’nden günlük armağanlar!',
		text1: `Kraliyet Bonus Mağazası’nda Taç Coin’ler servetinin anahtarıdır. </br>
        Gerçek bir hükümdara layık ödülleri al—Free Spin, Free Bet,
        Yatırım Bonusu, Nakit Bonusu ve diğer Kraliyet Ödülleri seni
        bekliyor.`,
		text2: `Makaraları sınırsızca çevir—her spin seni servetine bir adım daha
        yaklaştırır. </br>
        Kraliyet Görevleri’ni tamamlayarak ek Coin kazan ve rütbelerde
        yüksel. </br>
        Her seviye atladığında, hazinelerle dolu ekstra Taç Coin
        sandıkları senin olacak.`,
		text3: `
        Her gün krallığa adım at ve Bonus Takvimi’nin kapılarını aç.</br>
        Free Spin’den Yatırım Bonusuna, Coin’den XP’ye—her gün yeni
        bir kraliyet armağanı seni bekliyor.
      `
	},
	help: {
		have_trouble: 'Giriş yaparken bir sorun oluştu gibi görünüyor.',
		ask_help: 'Lütfen destek ekibimizle iletişime geçin.'
	}
};
